var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"ecvNavBox"},_vm._l((_vm.items),function(item,index){return _c('NavItem',{key:index,attrs:{"item":item,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }